import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SetPricingRequest } from 'happypaws-shared/src/Sitter/models/SetPricingRequest';
import { api } from '../../services/api';

export const useSetPricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SetPricingRequest) => {
      await api.post('/sitters/pricing', data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
